import style from "./BulkEditProduct.module.scss";
import primaryComponents from "../../primaryComponents";
import { useValidation } from "./useValidation";
import BulkEditProductLogic from "./useBulkEditProductLogic";
import LoaderHelper from "../LoaderHelper/LoaderHelper";
import globalStyles from "../../../assets/styles/base/globalPage.module.scss";
import { DeleteIcon } from "../../../assets/svgIcons";
import Modal from "../Modal/Modal";
import AmountField from "../../primaryComponents/AmountField";

const BulkEditProduct = ({
  selectedData,
  type,
  setSelectedData = () => {},
  closeModal = () => {},
}) => {
  const {
    pricingTypes,
    isLoadingPricingTypes,
    productsDetails,
    controlPrice,
    isUpdatingPrice,
    isDeletingProduct,
    isAdjusting,
    deleteType,
    setDeleteType,
    setControlPrice,
    setProductsDetails,
    handleBulkEditProduct,
    setIsAdjusting,
    handleBulkDeleteProduct,
  } = BulkEditProductLogic({
    selectedData,
    type,
    setSelectedData,
    closeModal,
  });

  const {
    handleSubmit,
    control,
    trigger,
    register,
    setValue,
    formState: { errors },
  } = useValidation({
    productsDetails,
    controlPrice,
  });

  const isPercentage = productsDetails?.adjustment_type === "PERCENTAGE";

  const handleAdjustmentTypeChange = (type) => {
    setProductsDetails((prev) => ({
      ...prev,
      adjustment_type: type,
      increase_percentage: "",
      decrease_percentage: "",
      increase_amount: "",
      decrease_amount: "",
    }));
    setValue("increase_percentage", "");
    setValue("decrease_percentage", "");
    setValue("increase_amount", "");
    setValue("decrease_amount", "");
  };

  const handleControlPriceChange = (direction) => {
    setProductsDetails((prev) => ({
      ...prev,
      increase_percentage: "",
      decrease_percentage: "",
      increase_amount: "",
      decrease_amount: "",
    }));
    setValue("increase_percentage", "");
    setValue("decrease_percentage", "");
    setValue("increase_amount", "");
    setValue("decrease_amount", "");
    setControlPrice(direction);
  };

  return (
    <>
      <div className={style.container}>
        <div
          className="items-center"
          style={{ background: "#F3F3F3", margin: "-2.2rem", padding: "3rem" }}
        >
          <div style={{ background: "#FFFFFF", borderRadius: "8px" }}>
            <div className="d-flex align-items-center p-3">
              <h6 className="font-weight-bold mb-0">Adjust Selling Price</h6>
              {isAdjusting ? (
                <primaryComponents.Button
                  classNames="btn btn--success ml-auto"
                  onClick={handleSubmit(() => {
                    handleBulkEditProduct();
                  })}
                  isDisabled={isUpdatingPrice}
                  isLoading={isUpdatingPrice}
                >
                  Save (
                  {selectedData?.is_select_all
                    ? selectedData?.totalItemsAcross
                    : selectedData?.selected_ids?.length}
                  )
                </primaryComponents.Button>
              ) : (
                <primaryComponents.Button
                  classNames="btn btn--primary ml-auto"
                  onClick={() => setIsAdjusting(true)}
                >
                  Adjust
                </primaryComponents.Button>
              )}
            </div>
            {isAdjusting && (
              <>
                <hr />
                <div className="pl-5 pr-5 pb-1 pt-3">
                  <div className="w-100">
                    <LoaderHelper
                      isLoading={isLoadingPricingTypes}
                      classNames={"mt-2"}
                    >
                      <primaryComponents.SelectField
                        value={"Select Pricing type(s)"}
                        control={control}
                        isRequired
                        label={
                          "Select a pricing type to bulk update its selling price"
                        }
                        name="pricing_type_id"
                        options={pricingTypes}
                        onChange={(value) => {
                          setProductsDetails((prev) => ({
                            ...prev,
                            pricing_type_id: value,
                          }));
                          setValue("pricing_type_id", value, {
                            shouldValidate: true,
                          });
                        }}
                        isSearchable={false}
                        floatError={false}
                        nameKey="label"
                        idKey="id"
                        register={register}
                        errorMessage={errors.pricing_type_id}
                      />
                    </LoaderHelper>
                  </div>

                  <div
                    className="d-flex align-items-center my-4"
                    style={{ gap: "10px" }}
                  >
                    <p>Adjustment Type:</p>

                    <div className="d-flex" style={{ gap: "20px" }}>
                      <primaryComponents.RadioButton
                        name={"priceAdjustmentType"}
                        id={"PERCENTAGE"}
                        checked={isPercentage}
                        onChange={() =>
                          handleAdjustmentTypeChange("PERCENTAGE")
                        }
                      >
                        Percentage
                      </primaryComponents.RadioButton>
                      <primaryComponents.RadioButton
                        name={"priceAdjustmentType"}
                        id="FIXEDAMOUNT"
                        checked={!isPercentage}
                        onChange={() =>
                          handleAdjustmentTypeChange("FIXEDAMOUNT")
                        }
                      >
                        Fixed Amount
                      </primaryComponents.RadioButton>
                    </div>
                  </div>

                  <div>
                    <div>
                      <p className=" mb-1">Select a bulk update action:</p>
                    </div>

                    <div
                      className={`${globalStyles.cardWithBorder} white px-3 py-3 ${style.responsiveCard}`}
                      style={{ borderRadius: "8px" }}
                    >
                      <div className={style.adjustmentRow}>
                        <div className={style.adjustmentLabel}>
                          <primaryComponents.RadioButtonV2
                            name="priceDirection"
                            id="bulkIncreasePrice"
                            value="+"
                            checked={controlPrice === "+"}
                            onChange={() => handleControlPriceChange("+")}
                          />
                          <label
                            htmlFor="bulkIncreasePrice"
                            className="font-weight-semibold"
                          >
                            Increase selling price by:
                          </label>
                        </div>

                        <div className={style.adjustmentInput}>
                          {isPercentage ? (
                            <primaryComponents.PercentageInputFieldV2
                              percentBg={"#F3F3F3"}
                              percentColor={"#696677"}
                              control={control}
                              name="increase_percentage"
                              classNames="white"
                              isDisabled={controlPrice !== "+"}
                              type="number"
                              min={0}
                              step={0.01}
                              value={
                                productsDetails.increase_percentage?.slice(1) ||
                                ""
                              }
                              placeholder="Enter value from 0-100%"
                              onChange={({ target: { value } }) => {
                                setProductsDetails((prev) => ({
                                  ...prev,
                                  increase_percentage: controlPrice + value,
                                }));
                              }}
                              giveControl={false}
                              onKeyUp={() =>
                                errors.increase_percentage !== undefined &&
                                trigger("increase_percentage")
                              }
                              register={register}
                              errorMessage={errors.increase_percentage}
                            />
                          ) : (
                            <AmountField
                              name="increase_amount"
                              placeholder="Enter Amount"
                              isDisabled={controlPrice !== "+"}
                              value={productsDetails.increase_amount}
                              errorMessage={errors.increase_amount}
                              floatError={false}
                              onKeyUp={() =>
                                errors.increase_amount !== undefined &&
                                trigger("increase_amount")
                              }
                              onChange={({ target: { value } }) => {
                                setProductsDetails((prev) => ({
                                  ...prev,
                                  increase_amount: value,
                                }));
                                setValue("increase_amount", value, {
                                  shouldValidate:
                                    errors.increase_amount !== undefined,
                                });
                              }}
                            />
                          )}
                        </div>
                      </div>

                      <hr />
                      <div className={style.adjustmentRow}>
                        <div className={style.adjustmentLabel}>
                          <primaryComponents.RadioButtonV2
                            name="priceDirection"
                            id="bulkDecreasePrice"
                            value="-"
                            checked={controlPrice === "-"}
                            onChange={() => handleControlPriceChange("-")}
                          />
                          <label
                            htmlFor="bulkDecreasePrice"
                            className="font-weight-semibold"
                          >
                            Decrease selling price by:
                          </label>
                        </div>

                        <div className={style.adjustmentInput}>
                          {isPercentage ? (
                            <primaryComponents.PercentageInputFieldV2
                              percentBg={"#F3F3F3"}
                              percentColor={"#696677"}
                              control={control}
                              name="decrease_percentage"
                              classNames="white"
                              isDisabled={controlPrice !== "-"}
                              type="number"
                              min={0}
                              step={0.01}
                              placeholder="Enter value from 0-100%"
                              value={
                                productsDetails.decrease_percentage?.slice(1) ||
                                ""
                              }
                              onChange={({ target: { value } }) => {
                                setProductsDetails((prev) => ({
                                  ...prev,
                                  decrease_percentage: controlPrice + value,
                                }));
                              }}
                              giveControl={false}
                              onKeyUp={() =>
                                errors.decrease_percentage !== undefined &&
                                trigger("decrease_percentage")
                              }
                              register={register}
                              errorMessage={errors.decrease_percentage}
                            />
                          ) : (
                            <AmountField
                              name="decrease_amount"
                              placeholder="Enter Amount"
                              isDisabled={controlPrice !== "-"}
                              value={productsDetails.decrease_amount}
                              errorMessage={errors.decrease_amount}
                              floatError={false}
                              onKeyUp={() =>
                                errors.decrease_amount !== undefined &&
                                trigger("decrease_amount")
                              }
                              onChange={({ target: { value } }) => {
                                setProductsDetails((prev) => ({
                                  ...prev,
                                  decrease_amount: value,
                                }));
                                setValue("decrease_amount", value, {
                                  shouldValidate:
                                    errors.decrease_amount !== undefined,
                                });
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="d-flex mt-3" style={{ gap: "10px" }}>
            <primaryComponents.Button
              classNames="btn btn--outline-red w-100"
              onClick={() => setDeleteType("ONLY_SELECTED")}
            >
              <DeleteIcon />
              <span className="ml-2">
                Delete Only Selected Products (
                {selectedData?.selected_ids?.length})
              </span>
            </primaryComponents.Button>

            <primaryComponents.Button
              classNames="btn btn--outline-red w-100"
              onClick={() => setDeleteType("ALL_ITEMS")}
            >
              <DeleteIcon />
              <span className="ml-2">
                Delete All Products in your inventory (
                {selectedData?.totalItemsAcross})
              </span>
            </primaryComponents.Button>
          </div>
        </div>
      </div>
      <Modal
        isActive={!!deleteType}
        width={500}
        closeModal={() => setDeleteType(null)}
      >
        <div className="p-4 text-center">
          <h4 className="font-weight-bold mb-3 error--text">
            Are you sure you want to delete the selected products?
          </h4>

          <div className="d-flex justify-content-center">
            <primaryComponents.Button
              classNames="btn btn--outline mr-2 w-75"
              loadingText={"Deleting..."}
              onClick={handleBulkDeleteProduct}
              isLoading={isDeletingProduct}
              isDisabled={isDeletingProduct}
            >
              Yes
            </primaryComponents.Button>
            <primaryComponents.Button
              classNames="btn btn--primary w-20"
              onClick={() => setDeleteType(null)}
            >
              No
            </primaryComponents.Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default BulkEditProduct;
